import { produce } from "immer";
import type { ImmerActionInput } from "../types";
import type { CookieStateType } from "../types/state-types";
import {
  REGISTER_USER_DONE,
  LOGIN_USER_DONE,
  CLEAR_REGISTER_USER_TOKEN,
  SIGNOUT,
  INVALIDATE_SESSION,
} from "../constants/actionTypes";
import {
  ClearRegisterUserTokenAction,
  CookieAction,
  InvalidateSessionAction,
  LoginUserDoneAction,
  RegisterUserDoneAction,
  SignoutAction,
} from "../types/cookie";

const INITIAL_STATE: CookieStateType = {
  registerUserToken: null,
};

const saveUserToken = ({
  action,
  draft,
}: ImmerActionInput<
  LoginUserDoneAction | RegisterUserDoneAction,
  CookieStateType
>) => {
  if (action.payload?.rememberToken) {
    draft.registerUserToken = action.payload.rememberToken;
  }
};

const clearToken = ({
  draft,
}: ImmerActionInput<
  ClearRegisterUserTokenAction | InvalidateSessionAction | SignoutAction,
  CookieStateType
>) => {
  draft.registerUserToken = null;
};

export default produce(
  (draft: CookieStateType, action: CookieAction): CookieStateType => {
    switch (action.type) {
      case REGISTER_USER_DONE:
      case LOGIN_USER_DONE:
        saveUserToken({ action, draft });
        break;
      case CLEAR_REGISTER_USER_TOKEN:
      case INVALIDATE_SESSION:
      case SIGNOUT:
        clearToken({ action, draft });
        break;
      default:
      // noop
    }
    return draft;
  },
  INITIAL_STATE,
);
